import { CatSkeleton } from '@blocks-react/components/Skeleton';
import styles from '../associated-dealer-search-result/style.module.scss';
import cx from 'classnames';
import { v4 as uuid } from 'uuid';

interface AssociatedDealerSearchResultListLoaderProps {
  loaders: number;
}

export const AssociatedDealerSearchResultListLoader = ({
  loaders = 3,
}: AssociatedDealerSearchResultListLoaderProps) => (
  <div>
    {Array(loaders)
      .fill(true)
      .map((_, index) => {
        const isLastValue = index === loaders - 1;
        cx();
        return (
          <div
            className={
              styles[`search-result-container${isLastValue ? '-last' : ''}`]
            }
            key={`skeletonCard-${uuid()}`}
            data-testid="skeleton-loader"
          >
            <div className="cat-u-margin-top-lg">
              <CatSkeleton
                width="40%"
                size="sm"
                className="cat-u-display-block cat-u-margin-bottom-md"
              />
              <CatSkeleton
                className="cat-u-display-block cat-u-margin-bottom-md"
                size="sm"
              />
              <CatSkeleton
                className="cat-u-display-block cat-u-margin-bottom-lg"
                size="sm"
              />
            </div>
          </div>
        );
      })}
  </div>
);
